// Smallest bill change is given with, when the company didn't configure it (sales settings "Múltiplo de Vuelto")
export const DEFAULT_CHANGE_MULTIPLE = 100
